import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

const BreadCrumb = ({ title, pageTitle, link, onClick }) => {
    const goToLink = link || '#';

    const TitleComponent = onClick ? (
        <h4 className="mb-sm-0">
            <span
                style={{
                    cursor: 'pointer',
                    color: '#495057', // Default text color
                    transition: 'all 0.2s',
                    borderBottom: '1px dashed #6c757d'  // Subtle dashed underline
                }}
                onClick={onClick}
                onMouseEnter={(e) => {
                    e.target.style.color = '#2b3144';
                    e.target.style.borderBottom = '1px solid #2b3144';
                }}
                onMouseLeave={(e) => {
                    e.target.style.color = '#495057';
                    e.target.style.borderBottom = '1px dashed #6c757d';
                }}
            >
                {title} <i className="ri-arrow-right-up-line align-bottom ms-1" style={{ fontSize: '14px' }}></i>
            </span>
        </h4>
    ) : (
        <h4 className="mb-sm-0">{title}</h4>
    );

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        {TitleComponent}
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item">
                                    <Link to={goToLink}>{pageTitle}</Link>
                                </li>
                                <li className="breadcrumb-item active">{title}</li>
                            </ol>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;
